/*
  The TikTok Events 2.0 API supports four different event types.
  However, currently, KatKin only sends TikTok events originating
  from the KatKin website, so the other three event types are currently disabled.
*/
export enum TikTokEventSourceEnum {
  Web = "web",
  // App = "app",
  // Offline = "offline",
  // Crm = "crm",
}

/**
 * Tracking events are documented in docs/tracking/tiktok.md (see docs/tracking/README.md).
 * If you add, remove or change when an event is sent, update that doc in the same PR
 * and let the Acquisition and Data teams know.
 */
export enum TikTokEventEnum {
  AddToCart = "AddToCart",
  CompleteRegistration = "CompleteRegistration",
  InitiateCheckout = "InitiateCheckout",
  CompletePayment = "CompletePayment",
  PageView = "PageView",
}

export type ITikTokEventTrackResponse = {
  code: number;
  message: string;
  request_id: string;
};

export type ITikTokEventTrackUserParameters = {
  ttclid?: string;
  email?: string[];
  phone?: string[];
  ip?: string;
  user_agent?: string;
  external_id?: string;
  ttp?: string;
};

export type ITikTokEventTrackPageParameters = {
  url: string;
  referrer?: string;
};

export type ITikTokEventContent = {
  content_id?: string;
  content_type?: "product" | "product_group";
  content_name?: string;
  content_category?: string;
  quantity?: number;
  price?: number;
  brand?: string;
};

export type ITikTokEventProperties = {
  /** ISO 4217 currency code, e.g. GBP */
  currency?: string;
  value?: number;
  content_type?: "product" | "product_group";
  contents?: ITikTokEventContent[];
};

export type ITikTokEventTrackData = {
  event: TikTokEventEnum;
  /** The time when the evnet occured measured in seconds */
  event_time: number;
  event_id: string;
  user?: ITikTokEventTrackUserParameters;
  page: ITikTokEventTrackPageParameters;
  properties?: ITikTokEventProperties;
};

export type ITikTokEventTrackBaseRequest = {
  event_source: TikTokEventSourceEnum;
  test_event_code?: string;
  data: ITikTokEventTrackData[];
};
